// extracted by mini-css-extract-plugin
export default {"slideshow":"yI7103"};